import { BO, BusinessObjectBase, Weaver } from "@skylab-shared/core";
import { IntegrationModel } from "./integration.model";

@BO({ modelType: IntegrationModel })
export class IntegrationBO extends BusinessObjectBase<IntegrationModel> {
	public constructor(
		weaver: Weaver,
	) {
		super(weaver);
	}
}
